import { useAuth } from '@/store/auth/auth.store';
import { hasAnyRole, isGuestAudience, type UserRole } from '@/utils/roles';

export const useRoles = () => {
  const userRoles = useAuth((state) => state.session?.userRoles);
  const primaryRole = useAuth((state) => state.session?.primaryRole);
  const services = useAuth((state) => state.session?.services);
  const signedUpAs = useAuth((state) => state.session?.signed_up_as);

  return {
    hasAnyRole: (roles: readonly UserRole[]) => hasAnyRole(userRoles, roles),
    userRoles,
    primaryRole,
    isGuestAudience: isGuestAudience(services, signedUpAs),
  };
};
